import { render, staticRenderFns } from "./SlotDoorprize.vue?vue&type=template&id=409918cf"
import script from "./SlotDoorprize.vue?vue&type=script&lang=js"
export * from "./SlotDoorprize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports